<template>
    <div :class="[
        'typo',
        themeClass
    ]">
        <div v-bastards>
            <slot />
        </div>

        <div
            v-bastards
            v-if="html"
            v-html="html"
        />
    </div>
</template>

<script>
import ThemeClassMixin from '@/mixins/ThemeClassMixin'

export default {
    mixins: [
        ThemeClassMixin
    ],

    props: {
        html: {
            type: String,
            required: false,
            default: ''
        }
    },

    data () {
        return {
            themeClassPrefix: 'typo--'
        }
    }
}
</script>

<style lang="scss">
.typo {
    &--color-secondary {
        color: $color-secondary;
    }

    &--color-contrast {
        color: $color-default-contrast;
    }

    &--wrapped {
        padding: 0 35px;
    }

    & + & {
        &:not(.typo--paddingless) {
            margin-top: 32px;
        }
    }

    p,
    ul > li,
    ol > li {
        font-size: 1.9rem;
        line-height: 2.4rem;

        > big {
            font-size: 2.1rem;
        }
    }

    ol {
        counter-reset: item;

        > li {
            counter-increment: item;
            position: relative;

            &:before {
                content: counter(item);
                @include size(18px);
                @include border-circle();
                color: $color-default-light;
                background-color: $color-secondary;
                text-align: center;
                position: absolute;
                top: 4px;
                left: 0;
                font-size: 1.4rem;
                line-height: 1.7rem;
                font-weight: $font-weight-bold;
            }
        }
    }

    ul {
        &.typo-list {
            > li {
                position: relative;

                &:before {
                    content: "\e902";
                    color: $color-primary;
                    font-family: 'noun_icon';
                    position: absolute;
                    left: -6px;
                    top: 6px;
                    font-size: 45px;
                }
            }
        }
    }

    strong {
        font-weight: $font-weight-bold;
    }

    &-box {
        background-color: $color-bg-primary;
        margin: 0 -35px;
        padding: 20px 35px 20px;
    }

    &-list {
        list-style-type: none;
        padding: 25px 0 0;

        > li {
            padding-left: 38px;

            &:nth-child(n + 2) {
                margin-top: 11px;
            }
        }
    }

    &-custom {
        &-coupon {
            .coupon-text {
                padding-top: 0;
            }

            .float-right {
                margin-right: 44px;
            }
        }

        &-lead {
            padding: 64px 0 18px;

            .badge {
                margin-right: 40px;
            }

            .lead-first {
                position: relative;
                top: -7px;
            }

            .lead-second {
                position: relative;
                top: -12px;
            }

            .lead-third {
                position: relative;
                top: -9px;
            }
        }
    }
}
</style>
